export abstract class BaseComponent {
    protected element!: HTMLElement;

    constructor() {
        // Subclasses should call this.element = this.create() in their constructor
        // after initializing their properties to avoid "undefined" errors.
    }

    protected abstract create(): HTMLElement;

    public getElement(): HTMLElement {
        return this.element;
    }

    protected escapeHtml(value: string): string {
        return value
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/\"/g, "&quot;")
            .replace(/'/g, "&#39;");
    }
}
